import { getColorSwatchFromColor } from './getColorSwatchFromColor';
export function enhanceTheme(theme) {
  var _theme$palette = theme.palette,
      primary = _theme$palette.primary,
      success = _theme$palette.success,
      warning = _theme$palette.warning,
      error = _theme$palette.error;
  return Object.assign(Object.assign({}, theme), {
    palette: Object.assign(Object.assign({}, theme.palette), {
      primary: Object.assign(Object.assign({}, primary), getColorSwatchFromColor(primary.main)),
      success: Object.assign(Object.assign({}, success), getColorSwatchFromColor(success.main)),
      warning: Object.assign(Object.assign({}, warning), getColorSwatchFromColor(warning.main)),
      error: Object.assign(Object.assign({}, error), getColorSwatchFromColor(error.main))
    })
  });
}